import { View } from "@webhandle/backbone-view"
import { controls, propertyTile } from "../templates/properties-widget.mjs"

export class PropertiesWidget extends View {
	constructor(options) {
		super(options)
		this.lastProperties = this.properties
	}

	preinitialize(options) {
		this.events = Object.assign({}, {
			'click .filter .buttons button': 'filterButtonClicked',
			'submit .search form': 'searchSubmitted',
			'click .': function (evt) {
				console.log(`${this.model} it got clicked`)
			}
		}, options.events)
		options.events = this.events
	}

	render() {
		let html = controls() + '<div class="the-properties">'

		for (let property of this.properties) {
			html += propertyTile(property)

		}
		html += '</div>'
		this.el.innerHTML = html
	}
	
	displayProperties(properties) {
		let html = ''
		properties.forEach(property => {
			html += propertyTile(property)
		})
		
		let thePropertiesEl = this.el.querySelector('.the-properties')
		thePropertiesEl.innerHTML = html

	}
	
	searchSubmitted(evt, selected) {

		evt.preventDefault()
		evt.stopPropagation()

		let searchText = this.el.querySelector('#search-properties-form input').value
		searchText = searchText.toLowerCase()
		let currentProperties = this.lastProperties.filter(property => {
			let json = JSON.stringify(property).toLowerCase()
			if(json.indexOf(searchText) > -1) {
				return true
			}
			return false
		})

		this.displayProperties(currentProperties)
	}
	filterButtonClicked(evt, selected) {
		this.el.querySelector('#search-properties-form input').value = ''
		this.el.querySelectorAll('.filter .buttons button')
		.forEach(button => button.classList.add('unselected'))
		selected.classList.remove('unselected')
		
		let selectedType = selected.getAttribute('data-listing-type')
		
		let currentProperties = this.properties.filter(property => {
			let type = property.propertyType.toLowerCase()
			if(selectedType === 'all') {
				return true
			}
			if(selectedType === 'for-sale' && (type === 'for sale' || type === 'for sale or lease') ) {
				return true
			}
			
			if(selectedType === 'for-lease' && (type === 'for lease' || type === 'for sale or lease') ) {
				return true
			}

			if(selectedType === 'sold' && (type !== 'for lease' && type !== 'for sale or lease' && type !== 'for sale') ) {
				return true
			}
			
			return false
		})
		this.lastProperties = currentProperties
		
		this.displayProperties(currentProperties)
		
	}

}